<template>
  <div>
    <ul class="flex mt-4">
      <li>
        <vs-checkbox v-model="selectedMonday" :disabled="disableComponent">Mon</vs-checkbox>
      </li>
      <li>
        <vs-checkbox v-model="selectedTuesday" :disabled="disableComponent">Tue</vs-checkbox>
      </li>
      <li>
        <vs-checkbox v-model="selectedWednesday" :disabled="disableComponent">Wed</vs-checkbox>
      </li>
      <li>
        <vs-checkbox v-model="selectedThursday" :disabled="disableComponent">Thu</vs-checkbox>
      </li>
      <li>
        <vs-checkbox v-model="selectedFriday" :disabled="disableComponent">Fri</vs-checkbox>
      </li>
      <li>
        <vs-checkbox v-model="selectedSaturday" :disabled="disableComponent">Sat</vs-checkbox>
      </li>
      <li>
        <vs-checkbox v-model="selectedSunday" :disabled="disableComponent">Sun</vs-checkbox>
      </li>
    </ul>
  </div>
</template>

<script>
import { CALENDAR_REPEAT_ON_DAYS } from "@/store/modules/marcom/data-model/calendar/index.js";

export default {
  components: {},
  props: {
    calendarEntry: Object,
    disableComponent: Boolean,
  },
  model: {
    prop: "calendarEntry",
    event: "calendarEntry-updated",
  },
  data() {
    return {
      CALENDAR_REPEAT_ON_DAYS,
      selectedDaysValue: 0,
      days: [
        CALENDAR_REPEAT_ON_DAYS.Monday,
        CALENDAR_REPEAT_ON_DAYS.Tuesday,
        CALENDAR_REPEAT_ON_DAYS.Wednesday,
        CALENDAR_REPEAT_ON_DAYS.Thursday,
        CALENDAR_REPEAT_ON_DAYS.Friday,
        CALENDAR_REPEAT_ON_DAYS.Saturday,
        CALENDAR_REPEAT_ON_DAYS.Sunday,
      ],
    };
  },
  computed: {
    selectedMonday: {
      get() {
        return (
          (this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            CALENDAR_REPEAT_ON_DAYS.Monday) ===
          CALENDAR_REPEAT_ON_DAYS.Monday
        );
      },
      set(value) {
        if (value === true)
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays |
            CALENDAR_REPEAT_ON_DAYS.Monday;
        else
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            ~CALENDAR_REPEAT_ON_DAYS.Monday;
      },
    },
    selectedTuesday: {
      get() {
        return (
          (this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            CALENDAR_REPEAT_ON_DAYS.Tuesday) ===
          CALENDAR_REPEAT_ON_DAYS.Tuesday
        );
      },
      set(value) {
        if (value === true)
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays |
            CALENDAR_REPEAT_ON_DAYS.Tuesday;
        else
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            ~CALENDAR_REPEAT_ON_DAYS.Tuesday;
      },
    },
    selectedWednesday: {
      get() {
        return (
          (this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            CALENDAR_REPEAT_ON_DAYS.Wednesday) ===
          CALENDAR_REPEAT_ON_DAYS.Wednesday
        );
      },
      set(value) {
        if (value === true)
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays |
            CALENDAR_REPEAT_ON_DAYS.Wednesday;
        else
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            ~CALENDAR_REPEAT_ON_DAYS.Wednesday;
      },
    },
    selectedThursday: {
      get() {
        return (
          (this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            CALENDAR_REPEAT_ON_DAYS.Thursday) ===
          CALENDAR_REPEAT_ON_DAYS.Thursday
        );
      },
      set(value) {
        if (value === true)
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays |
            CALENDAR_REPEAT_ON_DAYS.Thursday;
        else
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            ~CALENDAR_REPEAT_ON_DAYS.Thursday;
      },
    },
    selectedFriday: {
      get() {
        return (
          (this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            CALENDAR_REPEAT_ON_DAYS.Friday) ===
          CALENDAR_REPEAT_ON_DAYS.Friday
        );
      },
      set(value) {
        if (value === true)
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays |
            CALENDAR_REPEAT_ON_DAYS.Friday;
        else
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            ~CALENDAR_REPEAT_ON_DAYS.Friday;
      },
    },
    selectedSaturday: {
      get() {
        return (
          (this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            CALENDAR_REPEAT_ON_DAYS.Saturday) ===
          CALENDAR_REPEAT_ON_DAYS.Saturday
        );
      },
      set(value) {
        if (value === true)
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays |
            CALENDAR_REPEAT_ON_DAYS.Saturday;
        else
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            ~CALENDAR_REPEAT_ON_DAYS.Saturday;
      },
    },
    selectedSunday: {
      get() {
        return (
          (this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            CALENDAR_REPEAT_ON_DAYS.Sunday) ===
          CALENDAR_REPEAT_ON_DAYS.Sunday
        );
      },
      set(value) {
        if (value === true)
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays |
            CALENDAR_REPEAT_ON_DAYS.Sunday;
        else
          this.calendarEntry.calendarRepeatInterval.repeatOnDays =
            this.calendarEntry.calendarRepeatInterval.repeatOnDays &
            ~CALENDAR_REPEAT_ON_DAYS.Sunday;
      },
    },
  },
};
</script>

<style scoped>
</style>
